import { inject, NewInstance } from 'aurelia-framework';
import { PurchaseItemPriceService } from 'pages/quote-setup/purchase-item-prices/service';
import { ProjectService } from 'pages/quote-setup/projects/service';
import { PartService } from 'pages/quote-setup/parts/service';
import { PlantService } from 'pages/quote-setup/plants/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), PurchaseItemPriceService, ProjectService, PartService, PlantService, EventAggregator, DialogService)
export class PurchaseItemPriceEditor {
    constructor(controller, validationController, purchaseItemPriceService, projectService, partService, plantService, ea, dialogService) {
        this.controller = controller;
        this.dialogService = dialogService;
        this.purchaseItemPriceService = purchaseItemPriceService;
        this.projectService = projectService;
        this.plantService = plantService;
        this.partService = partService;
        this.ea = ea;
        this.purchaseItemPrice = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('projectId').required().withMessage('Project is required')
            .ensure('plantId').required().withMessage('Plant is required')
            .ensure('parentPartId').required().withMessage('Parent part is required')
            .ensure('childPartId').required().withMessage('Child part is required')
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.purchaseItemPrice = await this.purchaseItemPriceService.getById(model.id);
        }
    }

 

    addProject () {
        this.dialogService.open({ viewModel: this.projectService.editor });
    }

    addPart () {
      this.dialogService.open({ viewModel: this.partService.editor });
    }

    addPlant () {
        this.dialogService.open({ viewModel: this.plantService.editor });
    }

    addPurchaseItemPrice () {
        this.dialogService.open({ viewModel: this.purchaseItemPriceService.editor });
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.purchaseItemPrice.id) {
                    await this.purchaseItemPriceService.update(this.purchaseItemPrice);
                    toastr.success('Purchase item price was updated!');
                } else {
                    await this.purchaseItemPriceService.create(this.purchaseItemPrice);
                    toastr.success('New purchase item price was created!');
                }
                this.ea.publish('purchase-item-prices:updated', this.purchaseItemPrice);
                this.controller.ok(this.purchaseItemPrice);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}
